import { render } from "./Ringer.vue?vue&type=template&id=5149eb19"
import script from "./Ringer.vue?vue&type=script&lang=js"
export * from "./Ringer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__